import { formErrorAnatomy as e } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as t } from "@chakra-ui/react";
const { defineMultiStyleConfig: r } = t(e.keys), a = r({
  baseStyle: {
    text: {
      textStyle: "bodySmall",
      alignItems: "start",
      color: "red.500",
      display: "flex"
    },
    icon: {
      marginEnd: { base: 1, md: 2 },
      marginTop: { base: 0, md: "2px" }
    }
  }
});
export {
  a as default
};
